import Head from 'next/head';
import React from 'react';
interface Props {
  title: string;
  description: string;
  sharePath: string;
  type?: string;
  image?: string;
}
const OgMetadata = ({
  title = 'UR Play',
  description = '',
  sharePath = '/',
  type,
  image
}: Props) => {
  const ogImage = image || 'https://urplay.se/og-logo.png';
  return <Head data-sentry-element="Head" data-sentry-component="OgMetadata" data-sentry-source-file="OgMetadata.tsx">
      <meta property="og:title" content={title} data-sentry-element="meta" data-sentry-source-file="OgMetadata.tsx" />
      <meta property="og:locale" content="sv_SE" data-sentry-element="meta" data-sentry-source-file="OgMetadata.tsx" />
      <meta property="og:site_name" content="urplay.se" data-sentry-element="meta" data-sentry-source-file="OgMetadata.tsx" />
      <meta property="og:image" content={ogImage} data-sentry-element="meta" data-sentry-source-file="OgMetadata.tsx" />
      <meta property="og:url" content={`https://urplay.se${sharePath}`} data-sentry-element="meta" data-sentry-source-file="OgMetadata.tsx" />
      {type && <meta property="og:type" content={type} />}
      <meta property="og:description" content={description} data-sentry-element="meta" data-sentry-source-file="OgMetadata.tsx" />
    </Head>;
};
export default OgMetadata;